import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import { getCertificatesOfAnalysis } from '../shell/search.js';
import LoadingIndicator from '../react/components/LoadingIndicator.jsx';
import FileDownload from './fileDownload.jsx';

function reformatCertificateLink(url) {
    var reformatted = url;
    var country = cookie.get("PromegaCountry");

    if (country != null && country.length > 0 && country === "CHN" && url.length > 0) {
        // OldURLs: https://embed.widencdn.net/download/promega/0hsm7l663s/A1360_0000434322.pdf?u=7fvzhm&download=true
        // NewURLs: https://promega.widen.net/content/0hsm7l663s/original/A1360_0000434322.pdf?u=7fvzhm&download=true

        var cDNEndpoint = "scv10mr-cdnpre-p-cus-00.azureedge.net";

        var currentURL = window.location.href;
        if (currentURL.includes("devcloud")
            || currentURL.includes("dev")
            || currentURL.includes("stagecontent")
            || currentURL.includes("stagecloud")
            || currentURL.includes("stage")
            || currentURL.includes("cm-testcloud")
            || currentURL.includes("testcloud")
            || currentURL.includes("testcontent")
            || currentURL.includes("test")) {
            cDNEndpoint = "scv10mr-cdnpre-t-cus-00.azureedge.net";
        }

        var urlpathparts = url.split('/');
        var fileName = urlpathparts[urlpathparts.length - 1].split('?')[0];
        var id = urlpathparts[urlpathparts.length - 2] === "original" ? urlpathparts[urlpathparts.length - 3] : urlpathparts[urlpathparts.length - 2];
        reformatted = "https://" + cDNEndpoint + "/wdn/coa/" + fileName + "?f=" + id;
    }

    return reformatted;
}

const CertificateSearch = props => {
    const [loading, setLoading] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const [value, setValue] = useState('');
    const [inputDisabled, setInputDisabled] = useState(true);
    const [certificates, setCertificates] = useState([]);
    const {
        // placeholderText = 'Enter Catalog or Lot Number',
        searchButtonText = 'Search',
        noResultsText = 'No results',
        catNum,
        className,
        initialValue
    } = props;

    useEffect(() => {
        // Search on mount if an initial value was provided
        if (initialValue) {
            setValue(initialValue);
            searchCurrentValue(initialValue);
        }
    }, []);

    /**
     * 
     * @param {string} val The value for which to search
     * @param {boolean} matchName If true, only gets results that start with the same value passed for val
     */
    async function searchCurrentValue(val) {
        setLoading(true);
        setHasSearched(true);
        setCertificates([]);

        let results;
        try {
            if (catNum) {
                // If a catalog number was passed, filter to only include results relevant to that product
                results = await getCertificatesOfAnalysis(catNum, val);
                if (catNum || (initialValue && !hasSearched))
                    results = results.filter(current => current.Name.startsWith(catNum));
            }
            else
                results = await getCertificatesOfAnalysis(val);
        }
        catch (e) {
            results = [];
        }

        setLoading(false);

        setCertificates(results);
    }

    function handleChange(event) {
        if (event.target.value.trim().length > 0) {
            setInputDisabled(false);
        } else {
            setInputDisabled(true);
        }
        setValue(event.target.value);
    }

    function handleKeyDown(event) {
        if (event.keyCode === 13 && !setInputDisabled)
            searchCurrentValue(value);
        else if (event.keyCode === 27) {
            event.stopPropagation();
            event.target.blur();
        }
    }

    return <div className={`certificate-search${className && ` ${className}`}`} data-initial-state={JSON.stringify(props)}>
        <div className='content-item'>
            <input type='search' aria-label='Search for Certificates of Analysis' value={value} disabled={loading} autoComplete='off' onChange={handleChange} onKeyDown={handleKeyDown} />
        </div>

        {!loading && <div className='content-item'>
            <button className='button button--promega-sol' type='button' disabled={loading || inputDisabled} onClick={() => searchCurrentValue(value)}>{searchButtonText}</button>
        </div>}

        {loading && <LoadingIndicator />}

        {certificates.length > 0 && <div className='content-item'>{certificates.map(cert => <FileDownload key={cert.Links.AssetDownloadLink} units={false} GtmClasses='' Files={[{
            Title: cert.Name,
            Url: reformatCertificateLink(cert.Links.AssetDownloadLink),
            Extension: cert.Type,
            Size: cert.Size,
            IsDefault: true
        }]} />)}</div>}

        {hasSearched && !loading && certificates.length === 0 && <p>{noResultsText}</p>}
    </div>
}

// Checks if the page contains any instances of this component and attaches to them as necessary.
export function init() {
    const instances = Array.from(document.querySelectorAll('.certificate-search[data-initial-state]'));
    for (const instance of instances) {
        try {
            const props = JSON.parse(instance.dataset.initialState);
            ReactDOM.hydrate(React.createElement(CertificateSearch, props), instance.parentElement);
        }
        catch (e) { console.error(e); }
    }
}

export default CertificateSearch;
